'use client';
import React, { useEffect, useRef } from 'react';
import Script from 'next/script';
import PropTypes from 'prop-types';
import { CtaButton } from '../CtaButton';
import {
  Container,
  HeaderContainer,
  Heading,
  SubHeading,
  ButtonSection,
} from './styles.js';

export const ViddyVideo = ({
  heading,
  subheading,
  viddyVideoID,
  link,
  buttonVariant = 'egg',
  backgroundColor = 'background.base',
}) => {
  const ref = useRef(null);
  const viddyUrl =
    'https://d2208bmkizb2br.cloudfront.net/head/static/js/head.js';

  //* Append tag to document (component) body
  useEffect(() => {
    const tag = document.createElement('viddy-tag');
    tag.setAttribute('data-taghash', `${viddyVideoID}`);
    const component = ref.current;
    component.appendChild(tag);

    return () => component.removeChild(tag);
  }, [viddyVideoID]);

  return (
    <>
      <Script
        src={viddyUrl}
        data-viddy-analytics-type="segment"
        crossOrigin="anonymous"
      />
      <Container backgroundColor={backgroundColor}>
        <HeaderContainer>
          <Heading>{heading}</Heading>
          <SubHeading>{subheading}</SubHeading>
        </HeaderContainer>
        <div ref={ref} id="viddy_container"></div>
        {link && (
          <ButtonSection>
            <CtaButton href={link.target} variant={buttonVariant}>
              {link.text}
            </CtaButton>
          </ButtonSection>
        )}
      </Container>
    </>
  );
};

ViddyVideo.displayName = 'ViddyVideo';
ViddyVideo.propTypes = {
  heading: PropTypes.string,
  subheading: PropTypes.string,
  viddyVideoID: PropTypes.string,
  link: PropTypes.shape({
    target: PropTypes.string,
    text: PropTypes.string,
  }),
  buttonVariant: PropTypes.string,
  backgroundColor: PropTypes.string,
};
